import { useGetSafeClientCode } from '@/hooks/router'
import { ReactNode } from 'react'

import { Tabs, TabsList, TabsTriggerAsLink } from '@/components/tabs'

interface Props {
    marketCode: string
    instrumentSymbol: string
    active: 'overview' | 'orders'
    children?: ReactNode
}

export default function InstrumentNavigation({ marketCode, instrumentSymbol, active, children }: Props) {
    const clientCode = useGetSafeClientCode()

    const params = { client_code: clientCode, market_code: marketCode, instrument_symbol: instrumentSymbol } as any
    return (
        <div className="relative">
            <Tabs>
                <TabsList>
                    <TabsTriggerAsLink
                        to="/$client_code/markets/$market_code/instruments/$instrument_symbol"
                        params={params}
                        active={active === 'overview'}
                    >
                        Overview
                    </TabsTriggerAsLink>
                    <TabsTriggerAsLink
                        to="/$client_code/markets/$market_code/instruments/$instrument_symbol/orders"
                        params={params}
                        active={active === 'orders'}
                    >
                        Orders
                    </TabsTriggerAsLink>
                </TabsList>
            </Tabs>
            {children && <div className="absolute-center-y right-0">{children}</div>}
        </div>
    )
}
